var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Assuntos","titleIcon":"fas fa-tags"}},[_c('catalogo-crud',{attrs:{"tipo":"assunto","rotuloNovo":"NOVO ASSUNTO","nomeSingular":"assunto","placeholderBusca":"Pesquisar por descrição","campos":_vm.campos,"colunas":_vm.colunas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }